// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"327":"b69ee315","576":"e7876030","606":"1014a81f","717":"d7064856","864":"a7e2ed33","901":"20684126"}[chunkId] + ".chunk.css";
};